import { useQuery } from 'react-query';

import { getRecord } from '@utils/backend-api/universal';

export const NEWSLETTER_KEY = 'NEWSLETTER';

export default function useNewsletter(newsletterId) {
  const { data, isLoading } = useQuery(
    NEWSLETTER_KEY,
    async () =>
      await getRecord({
        model: 'Newsletter',
        id: newsletterId,
        attributes: [
          'access_level',
          'author',
          'description',
          'frequency',
          'id',
          'image_url',
          'is_pro_only',
          'is_subscriber_only',
          'name',
          'offer_code',
          'order',
          'small_image_url',
        ],
        helpers: ['card_image_url_imgix'],
        relations: {
          author: { attributes: ['name'] },
        },
      })
  );

  return { newsletter: data?.result, isLoadingNewsletter: isLoading };
}
